<template>
  <el-dialog
    title="理赔资料模板"
    :visible="visible"
    width="620px"
    append-to-body
    @close="$emit('update:visible', false)"
  >
    <el-table v-loading="loading" :data="rows" border
      ><el-table-column prop="file_name" label="文件名称" min-width="260"
        ><template slot-scope="scope">{{
          scope.row.file_name || scope.row.filename
        }}</template></el-table-column
      ><el-table-column label="操作" width="100" align="center"
        ><template slot-scope="scope"
          ><el-link
            :href="scope.row.file_url || scope.row.url"
            target="_blank"
            type="primary"
            >下载</el-link
          ></template
        ></el-table-column
      ></el-table
    >
  </el-dialog>
</template>
<script>
import { getClaimProductFiles } from "@/api/claims-management";
export default {
  name: "ProductFilesDialog",
  props: { visible: Boolean, productId: [String, Number] },
  data() {
    return { loading: false, rows: [] };
  },
  watch: {
    visible(value) {
      if (value) this.load();
    }
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const res = await getClaimProductFiles({
          product_id: Number(this.productId)
        });
        this.rows = res.rows || [];
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
